import { cn } from "../../lib/utils"
import { useUiTranslation } from "../../localization/use-ui-translation"
import { SpinnerArc } from "./spinner-arc"

/**
 * A small spinning arc, 16 pixels by default, for something that is loading. Announced as a status with the
 * localized label "Loading". Use `className` to change its size or color, as it takes the text color.
 */
function Spinner({ className, ...props }: React.ComponentProps<"svg">) {
  const { t } = useUiTranslation()
  return (
    <SpinnerArc
      data-part="spinner"
      role="status"
      aria-label={t(($) => $.accessibility.loading)}
      className={cn("size-4 animate-spin", className)}
      {...props}
    />
  )
}

export { Spinner }
